<template>
  <div class="card card-custom card-stretch" id="kt_todo_list">
    <!--begin::Header-->
    <div class="card-header align-items-center flex-wrap py-6 border-0 h-auto">
      <!--begin::Toolbar-->
      <div class="d-flex flex-wrap align-items-center">
        <div class="d-flex align-items-center mr-1 my-2">
          <label
            data-inbox="group-select"
            class="checkbox checkbox-inline checkbox-primary mr-3"
          >
            <v-btn @click="dialog = !dialog" class="btn-add-with-text" small>
              <v-icon>mdi-plus</v-icon>
              {{ $t("remember.add") }}
            </v-btn>
          </label>
        </div>
      </div>
      <!--end::Toolbar-->
    </div>
    <hr style="margin-top: -20px" />
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body p-0">
      <!--begin::Responsive container-->
      <div
        class="table-responsive"
        style="max-height: 45rem; overflow-y: scroll"
      >
        <!--begin::Items-->
        <div
          class="list list-hover min-w-500px"
          v-for="(item, i) in plannings"
          :key="i"
          v-if="item.type === 'remember'"
          data-inbox="list"
        >
          <!--begin::Item-->
          <div
            class="d-flex align-items-start list-item card-spacer-x py-4"
            data-inbox="message"
          >
            <!--begin::Toolbar-->
            <div class="d-flex align-items-center">
              <!--begin::عملیات-->
              <div
                class="d-flex align-items-center mr-3 col"
                data-inbox="actions"
              >
                <!--begin::Checkbox-->
                <label
                  class="checkbox checkbox-inline checkbox-primary flex-shrink-0 mr-3"
                  @change="changeCheckbox(item.id, item.status)"
                  v-model="check"
                >
                  <input :checked="!item.status" type="checkbox" />
                  <span></span>
                </label>
                <!--end::Checkbox-->
              </div>
              <!--end::عملیات-->
            </div>
            <!--end::Toolbar-->

            <!--begin::Info-->
            <div class="flex-grow-1 mt-1 mr-2 col" data-toggle="view">
              <!--begin::Title-->
              <p
                :data-id="item.id"
                :class="!item.status ? 'text-decoration-line-through' : ''"
                class="font-weight-bolder mr-2 title-tack"
              >
                {{ item.title }}
              </p>
              <!--end::Title-->
            </div>
            <div class="row">
              <div
                v-if="isNow(item, plannings.now) === '='"
                class="col"
                v-b-tooltip.hover.right="persian(changeDate(item.remember_at))"
              >
                <div class="badge badge-orange">
                  {{ secondToHuman(item.until, plannings.now) }}
                </div>
              </div>
              <div
                v-if="isNow(item, plannings.now) === '>'"
                class="col"
                v-b-tooltip.hover.right="persian(changeDate(item.remember_at))"
              >
                <div class="badge badge-success">
                  {{ secondToHuman(item.until, plannings.now) }}
                </div>
              </div>
              <div
                v-if="isNow(item, plannings.now) === '<'"
                class="col"
                v-b-tooltip.hover.right="persian(changeDate(item.remember_at))"
              >
                <div class="badge badge-danger">
                  {{ secondToHuman(item.until, plannings.now) }}
                </div>
              </div>
            </div>

            <!--begin::Details-->
            <div
              class="d-flex align-items-center justify-content-center"
              data-toggle="view"
            >
              <!--begin::تاریخtime-->
              <div class="font-weight-bolder col" data-toggle="view">
                <div class="row">
                  <div class="col-md-6">
                    <v-btn text small @click="deleted(item)">
                      <v-icon color="#B31414">mdi-delete-empty</v-icon>
                    </v-btn>
                  </div>
                  <div class="col-md-6">
                    <v-btn text small @click="edit(item)">
                      <v-icon color="#FF8000">mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
              <!--end::تاریخtime-->
            </div>
            <!--end::Details-->
          </div>
          <!--end::Item-->
        </div>
        <!--end::Items-->
      </div>
      <!--end::Responsive container-->
    </div>

    <custom-popup
      v-model="dialog"
      max-width="400"
      :cons="cons"
      @on-reload="reloadDialog"
      reloadable
      :close-on-confirm="false"
    >
      <v-card flat>
        <v-card-text>
          <v-row class="mt-5" no-gutters>
            <v-flex xs12 sm12 md12 xl12 lg12>
              <v-text-field
                outlined
                :label="$t('remember.titleLabel')"
                dense
                v-model="title"
                :error-messages="errors.title"
              />
            </v-flex>
            <v-flex class="mt-0 pt-0" xs12 sm12 md12 xl12 lg12>
              <date-picker
                :locale="$i18n.locale === 'ar' ? 'ar' : $i18n.locale"
                :label="$t('remember.dateLabel')"
                format="YYYY-MM-DD HH:mm"
                type="datetime"
                :min="getTomorrow(plannings.tomorrow * 1000)"
                v-model="remember_at"
                :display-format="
                  $i18n.locale === 'fa'
                    ? 'jYYYY-jMM-jDD HH:mm'
                    : $i18n.locale === 'en' ||
                      $i18n.locale === 'en_US' ||
                      $i18n.locale === 'en_GB'
                    ? 'YYYY-MM-DD HH:mm'
                    : 'jYYYY-jMM-jDD HH:mm'
                "
              />
              <div v-if="errors.length != 0">
                <p
                  class="mt-2 text-danger"
                  v-if="errors.remember_at"
                  v-for="(des, ind) in errors.remember_at"
                  :key="ind"
                >
                  {{ des }}
                </p>
              </div>
            </v-flex>
          </v-row>
        </v-card-text>
      </v-card>
    </custom-popup>

    <!--end::Body-->
  </div>
</template>

<script>
import moment from "moment-jalaali";

export default {
  name: "Remember",

  props: ["plannings"],

  data() {
    return {
      cons: {},
      currentPage: 1,
      check: false,
      dialog: false,
      remember_id: null,
      updateable: false,
      title: null,
      errors: [],
      remember_at: null,
      time: 0,
      loading: false, // اضافه شد برای متدهای store و update
    };
  },

  watch: {
    "i18n.locale"() {
      this.cons = {
        title: this.updateable
          ? this.$t("remember.update")
          : this.$t("remember.add"),
        buttons: [
          {
            text: "",
            type: "submit",
            handler: this.updateable ? this.update : this.store,
          },
          { text: "", type: "close", handler: this.closed },
        ],
      };
    },
    plannings(val) {
      this.remember_at = val.tomorrow;
    },
  },

  mounted() {
    this.remember_at = moment(this.plannings.tomorrow * 1000).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    setInterval(() => {
      this.plannings.now = this.plannings.now + 1;
      Object.entries(this.plannings).forEach(([key, item]) => {
        if (["tomorrow", "now"].indexOf(key) <= -1)
          this.plannings[key].until = item.remember_at - this.plannings.now;
      });
    }, 1000);

    this.cons = {
      title: this.updateable
        ? this.$t("remember.update")
        : this.$t("remember.add"),
      buttons: [
        {
          text: "",
          type: "submit",
          handler: this.updateable ? this.update : this.store,
        },
        { text: "", type: "close", handler: this.closed },
      ],
    };
  },

  methods: {
    getTomorrow(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    changeDate(date) {
      if ($i18n.locale === "fa")
        return moment(date * 1000).format("HH:mm jYYYY-jM-jD");
      else if (
        $i18n.locale === "en" ||
        $i18n.locale === "en_US" ||
        $i18n.locale === "en_GB"
      )
        return moment(date * 1000).format("HH:mm YYYY-MM-DD");
      else if (
        $i18n.locale === "ar" ||
        $i18n.locale === "ar_iq" ||
        $i18n.locale === "ar_ae"
      )
        return moment(date * 1000).format("HH:mm jYYYY-jM-jD");
    },
    isNow(item, now) {
      item = moment(item.remain_at * 1000).format("YYYY-MM-DD");
      item = moment(item).unix();
      now = moment(now * 1000).format("YYYY-MM-DD");
      now = moment(now).unix();
      if (item === now) return "=";
      if (item > now) return ">";
      if (item < now) return "<";
    },
    secondToHuman(second, now) {
      const suffix =
        second > 0
          ? this.$t("remember.timeSuffixFuture")
          : this.$t("remember.timeSuffixPast");
      second = Math.abs(Number(second));
      let day = Math.floor(second / 86400);
      let hour = Math.floor((second % 86400) / 3600);
      let minutes = Math.floor((second % 3600) / 60);
      second = Math.floor((second % 3600) % 60);
      return `${Math.abs(day)} ${this.$t("remember.days")} ${Math.abs(
        hour
      )} ${this.$t("remember.hours")} ${Math.abs(minutes)} ${this.$t(
        "remember.minutes"
      )} ${Math.abs(second)} ${this.$t("remember.seconds")} ${suffix}`;
    },
    async changeCheckbox(id, status) {
      if (!status) {
        this.check = true;
        await this.changeRememberStatus(true, id);
        return true;
      }
      await this.changeRememberStatus(false, id);
      return true;
    },
    changeRememberStatus(status = 0, id) {
      this.$modal.showLoading();
      this.requestApiPut("user/change-remember", { status, id })
        .then(({ data }) => {
          this.$emit("getRemember");
          this.$modal.hideLoading();
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
        });
    },
    edit(item) {
      this.dialog = true;
      this.updateable = true;
      this.remember_id = item.id;
      this.title = item.title;
      this.remember_at = moment(item.remember_at * 1000).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    async deleted(item) {
      if (await this.$modal.yesNo(this.$t("remember.confirmDelete"))) {
        this.$modal.showLoading();
        this.requestApiDelete(`user/planning/${item.id}`)
          .then(({ data }) => {
            this.$toast.success(this.$t("remember.deleteSuccess"));
            this.$modal.hideLoading();
            this.$emit("getRemember");
          })
          .catch(({ response }) => {
            this.$modal.hideLoading();
          });
      }
    },
    reloadDialog() {
      this.remember_at = moment(this.plannings.tomorrow * 1000).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.title = "";
      this.errors = [];
    },
    closed() {
      this.errors = [];
      this.dialog = false;
      this.updateable = false;
      this.title = null;
      this.remember_at = this.getTomorrow(this.plannings * 1000);
    },
    async store() {
      this.loading = true;
      await this.requestApiPost("user/create-remember", {
        title: this.title,
        remember_at: this.remember_at,
      })
        .then(({ data }) => {
          this.dialog = false;
          this.$emit("getRemember");
          this.$toast.success(this.$t("remember.createSuccess"));
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async update() {
      this.loading = true;
      this.errors = [];
      await this.requestApiPut(`user/update-remember/${this.remember_id}`, {
        remember_at: this.remember_at,
        title: this.title,
        method: "put",
      })
        .then(({ data }) => {
          this.closed();
          this.$toast.success(this.$t("remember.updateSuccess"));
          this.$emit("getRemember");
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.badge-orange {
  color: #fff;
  background-color: darkorange;
}

.badge-success {
  color: #fff;
  background-color: #02b30b !important;
}
</style>
